
export default function SocialProof() {
  const proofPoints = [
    {
      icon: 'ri-bar-chart-box-line',
      title: 'Data-Driven Methodology',
      description: 'Using Google Analytics, Business Profile insights, and proven frameworks'
    },
    {
      icon: 'ri-tools-line',
      title: 'Built for Trades & Services',
      description: 'Designed specifically for UK service businesses like yours'
    },
    {
      icon: 'ri-chat-3-line',
      title: 'No Technical Jargon',
      description: 'Clear, actionable insights you can understand and implement'
    }
  ];

  return (
    <section className="bg-[#FAFBFC] py-20">
      <div className="max-w-[900px] mx-auto px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white border border-gray-200 rounded-full text-sm mb-6 shadow-sm">
            <span className="w-1.5 h-1.5 bg-[#FF6B35] rounded-full"></span>
            <span className="text-[#1A1F36] font-medium">Built for Real Businesses</span>
          </div>
          <h2 className="text-3xl lg:text-[32px] font-bold text-[#1A1F36]">
            Trusted by <span className="text-[#FF6B35]">UK Service Businesses</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mt-10">
          {proofPoints.map((point, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 text-center hover:shadow-lg transition-all duration-300 group border border-gray-100 hover:border-[#FF6B35]/20"
            >
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-[#FF6B35]/5 rounded-2xl group-hover:bg-[#FF6B35]/10 transition-colors duration-300">
                <i className={`${point.icon} text-3xl text-[#FF6B35]`}></i>
              </div>
              <h3 className="text-lg font-bold text-[#1A1F36] mb-2">
                {point.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                {point.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
